/**
 * supabase.functions.invoke puts non-2xx bodies on error.context (a Response),
 * not in data. Prefer that body message over the generic "non-2xx" string.
 */
export async function getFunctionsInvokeErrorMessage(
  error: unknown,
  payload?: { error?: string } | null,
  fallback = 'Failed to delete account.'
): Promise<string> {
  if (payload?.error) return payload.error;

  const context = (error as { context?: unknown } | null | undefined)?.context;
  if (context && typeof (context as Response).json === 'function') {
    try {
      const body = (await (context as Response).json()) as {
        error?: string;
        message?: string;
        msg?: string;
      };
      if (body?.error) return String(body.error);
      if (body?.message) return String(body.message);
      if (body?.msg) return String(body.msg);
    } catch {
      // ignore JSON parse failures
    }
  }

  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
